import Cookies from "js-cookie";
import { IUserDetails } from "../constants/interface";
import { defaultApiInt, fetchDataV2, getDataNoTokenV2, newApiFetchV2, updateDataV2 } from "./utils";

export const updateHomePageUrl = (data: Record<string, string>): defaultApiInt => newApiFetchV2("/update_default_url/", data);

// Partial<IUserDetails> (not the full shape) - the backend updates a user record based on
// whatever fields it receives, with no way to distinguish "the caller means to touch every one of
// these" from "the caller just resent everything unchanged" - callers should only ever pass the
// fields that actually changed (see utils/getChangedFields.ts), not the whole object.
//
// `email` still has to go on the query string too (the route reads it from there to look up which
// user to update) - but the body ALSO needs it, because the backend's UserUpdate schema
// (schemas/user.py) inherits from UserGeneric, which redeclares `email` as a required EmailStr
// (not Optional, unlike UserRestricted's own declaration). Every caller here only ever passes the
// fields that changed on this page, which never includes email itself, so the body was missing it
// entirely and every update (including a plain theme toggle) 422'd with "body.email field required".
export const updateUserDetails = (email: string, payload: Partial<IUserDetails>): Promise<IUserDetails> =>
  updateDataV2(`/user_service/update-userdata?email=${email}`, { email, ...payload });

export const fetchTokenCXOPage = (): defaultApiInt => newApiFetchV2("/cxo_experiment_token", {});

export const isValidParameters = (paramString: string): defaultApiInt => fetchDataV2(`/digital_performance_filter_check${paramString}`);

export const fetchUserDetailsData = (email: string): defaultApiInt =>
  getDataNoTokenV2(`/user_service/get-current-user?email=${email}`, Cookies.get("access_token"));

export const notifyGoogleAccountAssociated = (dashboard: string): defaultApiInt =>
  getDataNoTokenV2(`/user_service/global-ms-sales-google-account-associated?dashboard=${dashboard}`, Cookies.get("access_token"));
